import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'ims-not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.less']
})
export class NotFoundPageComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
    console.log('pnf');
  }

}
